import NotifikaciaHistoriaListPage from './NotifikaciaHistoriaListPage';

export default NotifikaciaHistoriaListPage;
